import styled from 'styled-components';

const SingleImageStyle = styled.div`
	&.imageWrap {
		margin-bottom: var(--portfolioItemMarg);

		.full {
			width: 100%;
			padding-top: 59%;

			img {
				min-width: 100%;
			}
		}

		.fullAuto {
			width: 100%;
			padding-top: 0;

			> div {
				position: relative !important;
				inset: unset;

				img {
					position: relative !important;
					top: unset !important;
					left: unset !important;
					right: unset !important;
					bottom: unset !important;
				}
			}
		}

		.right {
			padding-top: 59%;

			@media only screen and (min-width: ${(props) => props.theme.mediaQuery.TabletSizeS}) {
				padding-top: 40%;
				text-align: right;

				img {
					max-width: 68%;
					left: unset !important;
				}
			}
		}

		.left {
			padding-top: 59%;

			@media only screen and (min-width: ${(props) => props.theme.mediaQuery.TabletSizeS}) {
				padding-top: 40%;

				img {
					max-width: 68%;
				}
			}
		}
	}
`;

export default SingleImageStyle;
